<template>
  <van-tabs v-model="active" @click="onClick" :color="color">
    <van-tab title="进度">
      <router-view class="systemContent" @paramSend="paramGet" />
    </van-tab>
    <van-tab title="详情">
      <router-view/>
    </van-tab>
  </van-tabs>
</template>
<script>
import Vue from 'vue'
import { Tab, Tabs, Notify } from 'vant'
import { getBizTokenReq } from '@/api/manage'

Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Notify)
export default {
  data () {
    return {
      active: 0,
      color: '#008ACB',
      path: '',
      linkedId: '',
      stepCode: '',
      stepName: ''
    }
  },
  methods: {
    onClick (name, title) {
      if (this.stepCode === '6') {
        Notify({ type: 'danger', message: '当前业务已挂起，无法继续办理' })
      } else if (this.stepName === '人脸识别') {
        const params = {
          token: this.$cookies.get('token'),
          linkedId: this.linkedId
        }
        getBizTokenReq(params).then(response => {
          const res = response.data
          console.log(res)
          if (res.code === 200) {
            const bizData = JSON.parse(res.data)
            console.log(bizData)
            window.location.href = bizData.Url
          }
        })
          .catch((res) => {
            Notify({ type: 'danger', message: '获取BizToken失败' })
          })
      } else {
        if (name === 0) {
          this.$router.push({ name: 'rateOfAdv' })
        } else {
          this.$router.push({
            path: this.path,
            query: {
              token: this.$cookies.get('token'),
              linkedId: this.linkedId
            }
          })
        }
      }
    },
    // 接收子组件参数
    paramGet (data) {
      this.stepName = data.data.stepName
      this.linkedId = data.data.linkedId
      this.path = data.data.localPage
      this.stepCode = data.data.stepCode
    }
  }
}
</script>
